import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Map} from 'immutable';
import DatePicker from 'react-datepicker';
import {Link} from 'react-router-dom';
import moment from 'moment';
import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {ButtonSuccessModal, ButtonDangerModal, ButtonWrap} from 'components/buttons';
import Breadcrumbs from 'components/breadcrumbs';
import {PageHead} from 'components/header/components';
import {Divider, Label} from 'components/common';
import {Error} from 'components/errors';
import Box from 'components/box';
import Input from 'form/input';
import {ButtonDefault} from 'components/buttons';
import Table from 'components/table';

import close from 'images/general/close.svg';

import {changeMailValue, submitNewMail, loadMailDetail, mailCleanStore, loadResponsibleStaff, changeResponsibleStaff, changeStaffAll} from 'redux/actions/admin/mailing';

const mapStateToProps = state => ({
  item: state.adminMails.get('mailItem'),
  hasError: state.adminMails.get('mailSubmitError'),
  isSubmitting: state.adminMails.get('mailIsSubmitting'),
  staff: state.adminMails.get('responsibleStaff'),
  submitAllStaff: state.adminMails.get('submitAllStaff')
});

const mapDispatchToProps = dispatch => ({
	onValueChange: (value, key) => dispatch(changeMailValue(value, key)),
	onMount: id => dispatch(loadMailDetail(id)),
	loadStaff: (level, limit, offset) => dispatch(loadResponsibleStaff(level, limit, offset)),
	onSubmit: (document_id, id, all_staff) =>
		dispatch(submitNewMail('/admin/mailing/detail/', document_id, id, all_staff)),
	onClean: () => dispatch(mailCleanStore()),
	onStaffChange: (event, i) => dispatch(changeResponsibleStaff(event.target.checked, i)),
  onChangeAll: (boolType, level, limit, offset) => dispatch(changeStaffAll(boolType, level, limit, offset))
});


class CreateMail extends Component {

  state = {
    isOpen: false,
    modalOpen: false,
		error: false,
		errorMsg: ''
  }

	toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });

	toggleModal = () => this.setState(prevState => ({modalOpen: !prevState.modalOpen}));

	onModalOk = () => {
	  this.toggleModal()
	  this.props.history.goBack()
	}

	toggleAllCheckboxes = () => {
    this.props.staff.getIn([0, 'checked'])
			? this.props.onChangeAll(false, 2)
      : this.props.onChangeAll(true, 2)
	}

  onSubmit = event => {
		event.preventDefault()
		const documentId = this.props.match.params.document_id || this.props.item.getIn(['document_list', 0, 'document_data', 'id'])
		const responsibleStaff = this.props.staff.filter(item => item.get('checked') === true);
		if(responsibleStaff.size > 0){
      this.props.onSubmit(documentId, this.props.match.params.mail_id, this.props.submitAllStaff)
		} else {
			this.setState(() => ({ error: true, errorMsg: 'Оберіть хоча б одного адресата'}))
		}
	}

  renderError = () => this.state.error && <Error>{this.state.errorMsg}</Error>

	removeError = () => this.setState(() => ({ error: false, errorMsg: ''}))

	componentDidMount() {
		this.props.loadStaff(2);
		if (this.props.match.params.mail_id !== undefined) {
			this.props.onMount(this.props.match.params.mail_id);
		}

		if (this.props.match.params.document_id !== undefined) {
			this.props.onClean();
		}
    const date = this.props.item.get('time_mailing') ? moment(this.props.item.get('time_mailing')) : moment().add(3, 'month')
    this.props.onValueChange(date, 'time_mailing')
	}

	componentWillReceiveProps (nextProps) {
    if (nextProps.hasError) {
      this.setState(() => ({ error: true, errorMsg: 'При створенні розсилки виникла проблема. Перевірте будь-ласка всі поля.'}))
		} else {
      this.removeError()
		}
	}

	render() {

		if (this.props.item === undefined || this.props.staff === undefined) {
			return null;
		}
		return (
			<div>
					{this.props.match.params.mail_id ? (
						<Breadcrumbs>
								<li><Link to="/admin/">Головна</Link></li>
								<li><Link to="/admin/mailing/">Розсилки</Link></li>
						</Breadcrumbs>
          ):(
						<Breadcrumbs>
								<li><Link to="/admin/">Головна</Link></li>
								<li><Link to="/admin/mailing/">Розсилки</Link></li>
						</Breadcrumbs>
          )}
			<PageHead>
				<h2>{this.props.match.params.mail_id ? "Редагувати розсилку" : "Створити розсилку"}</h2>
			</PageHead>
			<Box title4={this.props.match.params.mail_id ? "Форма редагування розсилки" : "Форма створення розсилки"}>
				<form onSubmit={this.onSubmit}>
					<Input
						label="Опис розсилки:"
						max={511}
						placeholder="Введіть короткий опис розсилки"
						onChange={(event) => this.props.onValueChange(event.target.value, 'comment_mailing')}
						value={this.props.item.get('comment_mailing') ? this.props.item.get('comment_mailing') : ''}
					/>

					<Label>Термін виконання:</Label>

					<DatePicker
						locale="uk-UA"
						selected={this.props.item.get('time_mailing') ? moment(this.props.item.get('time_mailing')) : moment().add(3, 'month')}
						onChange={date => this.props.onValueChange(date, 'time_mailing')}
						showTimeSelect timeFormat="HH:mm" timeIntervals={15}
						dateFormat="DD-MM-YYYY HH:mm"

					/>
					<Divider>
            <ButtonDefault
							value={this.props.staff.getIn([0, 'checked']) ? "Прибрати всіх" : "Вибрати всіх"}
							onClick={this.toggleAllCheckboxes} />

						<Table black="black">
							<thead>
								<tr>
									<th>Вибір</th>
									<th>Адресат</th>
								</tr>
							</thead>
							<tbody>
								{
									this.props.staff.map((item, i) => (<tr key={i}>
										<td>
											<input
                        type="checkbox"
                        checked={item.get('checked')}
                        onChange={(event) => {
													this.props.onStaffChange(event, i)
												}}/>
										</td>
											{item.get('institution_data') ? (
												<td>{item.get('institution_data').get('full_title')} ({item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')} {item.get('user_data').get('middle_name')})</td>
											):(
												null
											)}

									</tr>))
								}
							</tbody>
						</Table>

					</Divider>

					<Divider>
						<ButtonDefault disabled={this.props.isSubmitting} type="submit" value="Зберегти"/>
						<ButtonDefault onClick={this.toggleModal} value="Вийти без збереження"/>
					</Divider>
					{this.renderError()}
				</form>
			</Box>

		    <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
                    className={{
                      base: 'modalContent',
                      afterOpen: 'myClass_after-open',
                      beforeClose: 'myClass_before-close'
                    }} contentLabel="Підтвердження запису"
                    overlayClassName={{
                      base: 'modalOverlay',
                      afterOpen: 'myOverlayClass_after-open',
                      beforeClose: 'myOverlayClass_before-close'
                    }}>
          <div>
            <Modal>
              <CloseModal>
                <div>
                  <img src={close} alt="закрити" onClick={this.toggleModal} />
                </div>
              </CloseModal>

              <ModalContent>
                <h3>
									Ви впевнені, що хочете вийти без збереження?
                  Всі внесені зміни будуть скасовані
                </h3>
                <ButtonWrap>
                  <ButtonSuccessModal onClick={this.onModalOk} value="Так"/>
                  <ButtonDangerModal value="Ні" onClick={this.toggleModal}/>
                </ButtonWrap>
              </ModalContent>

            </Modal>
          </div>
        </ReactModal>
		</div>
		)
	}
};

CreateMail.propTypes = {
	item: PropTypes.instanceOf(Map),
	hasError: PropTypes.bool,
	isSubmitting: PropTypes.bool,
	onValueChange: PropTypes.func,
	onSubmit: PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateMail);



// WEBPACK FOOTER //
// ./src/admin/mailing/create.js